/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SessionAverageComparison
 */
export interface SessionAverageComparison {
    /**
     * 
     * @type {string}
     * @memberof SessionAverageComparison
     */
    duration?: SessionAverageComparisonDurationEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionAverageComparison
     */
    xpEarned?: SessionAverageComparisonXpEarnedEnum;
    /**
     * 
     * @type {number}
     * @memberof SessionAverageComparison
     */
    percentDiff?: number;
}


/**
 * @export
 */
export const SessionAverageComparisonDurationEnum = {
    above: 'above',
    below: 'below',
    average: 'average'
} as const;
export type SessionAverageComparisonDurationEnum = typeof SessionAverageComparisonDurationEnum[keyof typeof SessionAverageComparisonDurationEnum];

/**
 * @export
 */
export const SessionAverageComparisonXpEarnedEnum = {
    above: 'above',
    below: 'below',
    average: 'average'
} as const;
export type SessionAverageComparisonXpEarnedEnum = typeof SessionAverageComparisonXpEarnedEnum[keyof typeof SessionAverageComparisonXpEarnedEnum];


/**
 * Check if a given object implements the SessionAverageComparison interface.
 */
export function instanceOfSessionAverageComparison(value: object): value is SessionAverageComparison {
    return true;
}

export function SessionAverageComparisonFromJSON(json: any): SessionAverageComparison {
    return SessionAverageComparisonFromJSONTyped(json, false);
}

export function SessionAverageComparisonFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionAverageComparison {
    if (json == null) {
        return json;
    }
    return {
        
        'duration': json['duration'] == null ? undefined : json['duration'],
        'xpEarned': json['xpEarned'] == null ? undefined : json['xpEarned'],
        'percentDiff': json['percentDiff'] == null ? undefined : json['percentDiff'],
    };
}

export function SessionAverageComparisonToJSON(json: any): SessionAverageComparison {
    return SessionAverageComparisonToJSONTyped(json, false);
}

export function SessionAverageComparisonToJSONTyped(value?: SessionAverageComparison | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'duration': value['duration'],
        'xpEarned': value['xpEarned'],
        'percentDiff': value['percentDiff'],
    };
}

